module.exports = __webpack_public_path__ + "static/media/icon-pill-tennis.e32496c9.svg";